import { MenuItem } from '@src/common/components/Menu';
import { useToast } from '@src/common/hooks/useToast';
import { CancelOrderModal } from '@src/orders/components/orderActionsMenu/modal/CancelOrderModal';
import type { OrderListing } from '@src/orders/domain/OrderList';
import { OrderActions } from '@src/orders/domain/OrderList';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  order: OrderListing;
  onStatusChange: () => void;
};

export const CancelAction = ({ order, onStatusChange }: Props) => {
  const { t } = useTranslation();
  const [openCancelModal, setCancelModal] = useState(false);
  const { showSuccessToast, showErrorToast } = useToast();

  const openCancellationModal = () => {
    setCancelModal(true);
  };

  return (
    order.canDo(OrderActions.CANCEL) && (
      <>
        <MenuItem key={`${order.id}-cancel`} onClick={openCancellationModal}>
          {t('cancel')}
        </MenuItem>
        <CancelOrderModal
          open={openCancelModal}
          onClose={() => {
            setCancelModal(false);
          }}
          onSuccess={() => {
            showSuccessToast(t('orderSummary.cancelSuccess'));
            onStatusChange();
            setCancelModal(false);
          }}
          onError={() => {
            showErrorToast(t('orderSummary.cancelError'));
          }}
          order={order}
        />
      </>
    )
  );
};
